import React from 'react';
import { toast } from 'react-toastify';
import { CourseGroupV2 } from '../api/models/Course';
import { Environment } from '../Environment';

type Args = {
  /** bearer token from auth0 */
  token: string | undefined;
  /** get course groups of which person */
  personId: number | undefined;
};

export const useCourseGroups = (args: Args) => {
  const { token, personId } = args;

  const [isGettingCourseGroups, setIsGettingCourseGroups] = React.useState(false);
  const [courseGroups, setCourseGroups] = React.useState<CourseGroupV2[]>([]);

  const { api } = Environment.current();

  // get course groups (academic check)
  React.useEffect(() => {
    // make sure for personId, 0 is accepted
    if (token && personId !== undefined && !courseGroups.length) {
      (async () => {
        try {
          setIsGettingCourseGroups(true);
          const result = await api.getStudentCourseGroups(personId, token);
          setCourseGroups(result);
          setIsGettingCourseGroups(false);
        } catch (e) {
          toast.error(e.message);
          setIsGettingCourseGroups(false);
        }
      })();
    }
  }, [token, personId, courseGroups.length]);

  return { courseGroups, isGettingCourseGroups };
};
